import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: auto;
        height: auto;
        padding: 50px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-md);
            margin-block: 5px;
        }

        .btns{
            display: flex;
            align-items: center;
            margin-top: 25px;
            width: 100%;
            button{
                margin-right: 10px;
                width: auto;
            }
        }
    }

`
    
//! !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
const JobListAccessModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <p>Devamlı Araçlarım’a başarıyla kaydedilmiştir.</p>
            <p>Kamyoon Uygulamasına üye olarak da kayıtlıdır.</p>
            <p>Kamyoon’da kayıtlı bilgi ve belgelere erişmek için üyenin izni gerekmektedir.</p>
            <p>Erişim izni talep ettiğinizde üyeye bildirim gidecektir.</p>
            <p>üyenin kayıtlı (Ruhsat, Kimlik, Ehliyet, SRC, Araç Fotoğrafları vb.) bilgi ve belgelerine erişebileceksiniz.</p>
            <div className="btns">
                <Button width="150px" handleClick={() => dispatch(showModal("jobSmsModal"))} padding="10px" background="#fff" color={"#E85446"}>Erişim İzni Talep Et</Button>
                <Button width="150px" handleClick={() => dispatch(showModal("insertionQuestionModal"))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
            </div>
            
        </div>
    </Container>
  )
}

export default JobListAccessModal